import { AxiosRequestConfig } from 'axios';
import { ResponseApi } from 'api/interfaces';
import { IEnpointApis, getApiEndpoint } from 'library/Apis';
import api from 'services/ApiService';

export async function get<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  config?: AxiosRequestConfig
): Promise<ResponseApi<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await api.get<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data,
    };
  }
}

export async function post<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseApi<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await api.post<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data,
    };
  }
}

export async function put<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseApi<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await api.put<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data,
    };
  }
}

export async function del<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  config?: AxiosRequestConfig
): Promise<ResponseApi<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await api.delete<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data,
    };
  }
}
